import React from 'react';
import { Stack, Badge } from '@moda/om';
import { compact } from '@moda/portal-stanchions';
import {
  ProductDetailsFragment,
  ProductDetailsVariantFragment,
  SizeInventoryFragment
} from '../../../generated/types';
import { SizeGuideLink, hasSizeEquivalents } from '../../SizeGuide';
import { SizeSelector } from '../../SizeSelector';
import './ProductDetailsSize.scss';

type Props = {
  activeVariant: ProductDetailsVariantFragment;
  variant: ProductDetailsFragment;
  size: SizeInventoryFragment | null;
  handleSelectSize: (option: SizeInventoryFragment) => void;
};

export const ProductDetailsSize: React.FC<Props> = ({
  activeVariant,
  variant,
  size,
  handleSelectSize
}) => {
  const inventory = compact(activeVariant.inventory);
  const isOneSizedItem = inventory.length === 1 && inventory[0].size === 'OS';

  const showSizeGuide = hasSizeEquivalents(variant.sizeEquivalents);
  const showTopSection = showSizeGuide || variant.fitRecommendation != null;

  if (isOneSizedItem) return null;

  return (
    <Stack space={4} className="ProductDetailsSize">
      {showTopSection && (
        <Stack space={2}>
          <SizeGuideLink
            className="ProductDetailsSize__size-guide"
            sizes={compact(activeVariant.inventory)}
            sizeEquivalents={variant.sizeEquivalents}
            fitRecommendation={variant.fitRecommendation?.description}
          />

          {variant.fitRecommendation && (
            <Badge theme="noise">{variant.fitRecommendation.description}</Badge>
          )}
        </Stack>
      )}

      <SizeSelector
        variant={variant}
        activeVariantId={activeVariant.id}
        selected={size}
        onSelect={handleSelectSize}
      />
    </Stack>
  );
};
